import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedImage, setSelectedKey } from 'reduxStore/bracketOptionsSlice';
import { jsonData } from 'constant/jsonData';
import { materialData } from 'utils/imageData';
import { getDataBasedOnKey } from 'utils/utils';
import ImageCard from './ImageCard';

const getObjectFromLastKey = (selectedKey) => {
  const lastKey = [...selectedKey.keys()].pop();
  if (selectedKey.has(lastKey) && selectedKey.get(lastKey) !== undefined) {
    return selectedKey.get(lastKey).object; // Access the nested object
  }
  return null;
};

const ImageBox = ({ imgData }) => {
  const { currentLevel, selectedKey } = useSelector((store) => store.bracketOptions);
  const dispatch = useDispatch();
  const handleClick = (material = null) => {
    const level = currentLevel;
    const nestedObject = getObjectFromLastKey(selectedKey);

    const object1 = {
      level: level + 1,
      data: nestedObject || jsonData,
      value: imgData.tag,
      name: imgData.label
    };

    dispatch(setSelectedKey(object1));
    dispatch(setSelectedImage({ imgData }));

    // selecting material if available
    if (material) {
      // get image data for material as click is made on bracket image
      const materialImgData = materialData?.filter((data) => data.title == material)[0];
      const materialObject = {
        level: level + 2,
        data: getDataBasedOnKey(imgData.tag, nestedObject) || jsonData,
        value: materialImgData.tag,
        name: materialImgData.label
      };

      dispatch(setSelectedKey(materialObject));
      dispatch(setSelectedImage({ imgData: materialImgData }));
    }
  };

  return <ImageCard imgData={imgData} onClick={handleClick} />;
};

ImageBox.propTypes = {
  imgData: PropTypes.object
};

export default ImageBox;
